import React, { useState, useEffect } from "react";
import "../CSS/Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";

export default function Navbar() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  // Ambil user dari localStorage saat load
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  return (
    <header className="tk-navbar">
      <div className="tk-brand">
        <img
          src={process.env.PUBLIC_URL + "/assets/logobaruTibiSmart.png"}
          alt="TibiSmart"
          className="tk-logo"
        />
      </div>

      <nav className="tk-navlinks">
        <div className="nav-left">
          {/* HOME → Ringkasan Analitik Admin */}
          {user && (
            <Link to="/HalamanRingkasanAnalitikAdmin" className="nav-link">
              Home
            </Link>
          )}

          <a href="#about">About</a>
          <a href="#help">Help</a>
          <a href="#contact">Contact</a>

          {!user && (
            <Link to="/logintenagakesehatan">
              <button className="tk-login-btn">Log In</button>
            </Link>
          )}
        </div>

        {user && (
          <div
            className="navbar-user"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <span className="username">{user.username}</span>
            <FaUserCircle className="profile-icon" size={35} />

            {showDropdown && (
              <div className="dropdown-menu">
                <button onClick={handleLogout}>Logout</button>
              </div>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}
